/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import type { SnapIntegrations } from './types';

/**
 * Recommended set for Super App embed and full SNAP hosts.
 * `TripTypeSelector` is optional at runtime (one-way row stays hidden)
 * but should still be provided when Flights UI is available.
 */
export const RECOMMENDED_SNAP_INTEGRATIONS = [
  'TripTypeSelector',
] as const satisfies ReadonlyArray<keyof SnapIntegrations>;

export const getMissingSnapIntegrations = (
  integrations: Readonly<Partial<SnapIntegrations>>,
  required: ReadonlyArray<
    keyof SnapIntegrations
  > = RECOMMENDED_SNAP_INTEGRATIONS,
): Array<keyof SnapIntegrations> =>
  required.filter((key) => integrations[key] == null);

export const warnMissingSnapIntegrations = (
  integrations: Readonly<Partial<SnapIntegrations>>,
  context = 'SnapIntegrationsProvider',
): void => {
  if (typeof __DEV__ === 'undefined' || !__DEV__) {
    return;
  }

  const missing = getMissingSnapIntegrations(integrations);
  if (missing.length === 0) {
    return;
  }

  console.warn(
    `[${context}] Missing snap integrations: ${missing.join(', ')}. ` +
      'Pass them via SnapIntegrationsProvider or the Snap `integrations` prop. ' +
      'See packages/snap/README.md (Super App integration).',
  );
};
